import Config from './config';
import { Environment } from '../v2/types/config';

type EnvironmentDisplay = {
  label: string;
  titlePrefix: string;
  badgeClassName: string;
};

const ENVIRONMENT_DISPLAY: Partial<Record<Environment, EnvironmentDisplay>> = {
  [Environment.Development]: {
    label: 'Dev',
    titlePrefix: '[DEV]',
    badgeClassName: 'bg-[#d8deff] text-[#0021db]',
  },
  [Environment.Staging]: {
    label: 'Staging',
    titlePrefix: '[STG]',
    badgeClassName: 'bg-[#ffe8cc] text-[#c2410c]',
  },
};

const DEFAULT_NON_PRODUCTION_DISPLAY: EnvironmentDisplay = {
  label: 'Test',
  titlePrefix: '[TEST]',
  badgeClassName: 'bg-[#eae8e4] text-[#394642]',
};

export function getEnvironmentDisplay(): EnvironmentDisplay | null {
  const env = Config.REACT_APP_ENVIRONMENT;

  if (!env || env === Environment.Production) {
    return null;
  }

  return (
    ENVIRONMENT_DISPLAY[env as Environment] ?? {
      ...DEFAULT_NON_PRODUCTION_DISPLAY,
      label: env.charAt(0).toUpperCase() + env.slice(1),
      titlePrefix: `[${env.toUpperCase()}]`,
    }
  );
}

export function formatEnvironmentDocumentTitle(
  baseTitle = 'Homecoming',
): string {
  const display = getEnvironmentDisplay();
  return display ? `${display.titlePrefix} ${baseTitle}` : baseTitle;
}

export function shouldShowUnauthedContainerEnvironmentBadge(
  pathname: string,
): boolean {
  return (
    pathname.startsWith('/sign-up') ||
    pathname.startsWith('/join') ||
    pathname.startsWith('/reset') ||
    pathname.startsWith('/login/client') ||
    pathname === '/login' ||
    pathname.startsWith('/client/login-token')
  );
}
